import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LocationService } from '../public/location.service';
import { InactivityModalComponent } from '../public/store/inactivity-modal/inactivity-modal.component';
import { CustomerDataService } from './customerDataService';
import { Store } from '@ngrx/store';
import { InitializeOrder, ViewStateUpdate } from '../public/store/+state/stores.actions';
import { ClientStore } from '../stores/stores';
import { OrderService } from '../public/order.service';
import { getCurrentCartUuid } from '../public/store/+state/stores.selectors';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InactivityService {
  private userActivity: any;
  private modalShown: boolean = false;
  private inActivityTimer:number = 45000
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private cookieService: CookieService,
    private customerDataService: CustomerDataService,
    private locationService: LocationService,
    private store: Store,
    private orderService: OrderService,
    private route: ActivatedRoute
  ) {}

  // Set timeout for inactivity
  public setTimeout(selectedStore: any): void {
    clearTimeout(this.userActivity); // Clear any existing timer
    this.userActivity = setTimeout(() => this.openModal(selectedStore), this.inActivityTimer);
  }

  // Refresh user state on activity
  public refreshUserState(selectedStore: any): void {
    clearTimeout(this.userActivity);
    if (this.modalShown) {
      this.setTimeout(selectedStore);
    }
  }


  public navigateToOrderCapture() {
    this.router.navigate([], {
      fragment: null,
      relativeTo: null,
      replaceUrl: true,
      state: { clearCart: true }
    });
  }
  
  public reloadFunction(): void {
    location.reload();
  }
  
  public openModal(selectedStore: ClientStore): void {
    if (this.modalShown) {
      const dialogRef = this.dialog.open(InactivityModalComponent, {
        width: '490px',
        panelClass: 'cpanel-activity',
      });
  
      dialogRef.afterClosed().pipe(take(1)).subscribe((value) => {
        if (value === false) {
          this.navigateToOrderCapture();

          setTimeout(() => {
            this.store.dispatch(new InitializeOrder(selectedStore.id, this.orderService.getInitOrder(), {
              src: 'InactivityService',
              description: 'Inactivity timeout'
            }));
            this.customerDataService.cleanCustomerData();
          }, 500);
        }
      });
    }
  }

  // Setter for modalShown property
  public setModalShown(value: boolean): void {
    this.modalShown = value;
  }

  // Getter for modalShown property
  public getModalShown(): boolean {
    return this.modalShown;
  }
}